import React from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import _ from 'lodash';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { generateOptions } from '../../utils/Utils';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import moment from 'moment';
import { useFormik } from 'formik';
import {
    fetchContact,
    fetchCustomers,
    getCustomer,
} from '../../app/reducers/Customer/customerSlice';
import FormikAsyncSelect from '../../components/formik/FormikAsyncSelect';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import FormikMultiSelect from '../../components/formik/FormikMultiSelect';
import * as Yup from 'yup';
import {
    fetchInvoices,
    getInvoice,
    reset,
} from '../../app/reducers/Invoice/invoice.slice';
import { authAxiosInstance } from '../../utils/axiosConfig';
import QueryString from 'qs';
import { toast } from 'react-toastify';
import { AddTrackingIdModal } from './AddTrackingIdModal';
import EditMenu from '../../components/DropdownEditMenu/DropdownEditMenu';
import { Tracking } from './Tracking';
import { Send } from 'react-feather';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import { customIDs } from '../../utils/customIds';
import { PRINT_OPTIONS } from '../../utils/dropdownOptions';
import {
    fetchPrinters,
    printInvoice,
} from '../../app/reducers/Print/printSlice';
import PrinterSelect from '../Notification/PrinterSelect';
import ProgressBar from '../../components/progressBar/ProgressBar';
import InvoiceDataPopup from './InvoiceDataPopup';
import { ClipLoader, ClockLoader } from 'react-spinners';
import { Clock } from 'react-feather';
import { openReminderPopUp } from '../../app/reducers/ReminderPopUp/reminderPopUpSlice';
import PhoneIconBox from '../../components/infrastructure/PhoneIconBox';
import SecondaryButton from '../../components/infrastructure/Buttons/SecondaryButton';
import axios from 'axios';

const ViewInvoice = () => {
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [filterInvoicesData, setFilterInvoicesData] = useState([]);
    const [invoiceTrackingData, setInvoiceTrackingData] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentItem, setCurrentItem] = useState(0);
    const [totalItem, setTotalItem] = useState(0);
    const [printerSelectModalOpen, setPrinterSelectModalOpen] = useState(false);
    const [printOption, setPrintOption] = useState(PRINT_OPTIONS[0]);
    const [selectedPrinter, setSelectedPrinter] = useState(null);
    const [progressLoading, setProgressLoading] = useState(false);
    const [clickedInvoiceId, setClickedInvoiceId] = useState('');
    const [invoicePopupOpen, setInvoicePopupOpen] = useState(false);
    const [loadingReminder, setLoadingReminder] = useState(false);

    const dispatch = useDispatch();
    const { invoices, loading } = useSelector(getInvoice);
    // created on 16-11-22
    let filterStatus = ['sent', 'overdue', 'draft'];

    const handleStatusChangeOnSend = async (invoiceData) => {
        try {
            setIsLoading(true);
            if (invoiceData.current_sub_status === 'draft') {
                const resp = await authAxiosInstance.patch(
                    `invoice/${invoiceData.invoice_id}`,
                    {
                        status: 'sent',
                    }
                );
                await dispatch(fetchInvoices());
                return resp;
            } else {
                alert(`Sorry, Status is ${invoiceData.current_sub_status} `);
            }
        } catch (error) {
            console.log(error);
            toast.error('Something went wrong');
        } finally {
            setIsLoading(false);
        }
    };

    const computeColor = (inVoiceData) => {
        switch (inVoiceData) {
            case 'draft':
                return '#eeeeee';
            case 'overdue':
                return 'red';
            case 'sent':
                return 'green';
            case 'default':
                return '#000';
        }
    };

    const handleInvoiceTrackingId = (invoiceData) => {
        setInvoiceTrackingData(invoiceData);
        setModalIsOpen(true);
    };

    useEffect(() => {
        const resetInvoices = async () => {
            await dispatch(reset());
        };
        resetInvoices();
        dispatch(fetchPrinters());
    }, []);

    useEffect(() => {
        const getInvoices = async () => {
            if (page != 0) {
                let data = {};
                // if (formik.values.customer) {
                //   data["customer_id"] = formik.values.customer;
                //   (data["date_start"] = moment(formik.values.from).format(
                //     "YYYY-MM-DD"
                //   )),
                //     (data["date_end"] = moment(formik.values.to).format("YYYY-MM-DD"));
                // }
                const docs = await dispatch(
                    fetchInvoices({ ...data, page: page })
                );
                //   const filterDocs = docs?.payload?.invoices?.filter((el) =>
                //     // el.current_sub_status.includes(formik.values.filterStatus)
                //     formik.values.filterStatus.includes(el.current_sub_status)
                //   );
                //   if (filterDocs) {
                //     setFilterInvoicesData(filterDocs);
                //   }
            }
        };
        getInvoices();
    }, [page]);

    const openPrintModal = (e) => {
        e.stopPropagation();
        setPrinterSelectModalOpen(true);
    };

    const printInvoices = async () => {
        try {
            if (selectedPrinter.value) {
                setProgressLoading(true);
                setTotalItem(selectedRows.length);

                for (let i = 0; i < selectedRows.length; i++) {
                    const element = selectedRows[i];
                    await dispatch(
                        printInvoice({
                            invoiceId: element.invoice_id,
                            printerId: selectedPrinter.value,
                            printInvoice: ['all', 'invoice'].includes(
                                printOption.value
                            ),
                            printReport: ['all', 'report'].includes(
                                printOption.value
                            ),
                        })
                    );
                    setCurrentItem(currentItem + 1);
                }
            }
        } catch (error) {
            console.log(error);
            toast.error('error printing data');
        }
    };

    const handleSendInvoice = async(row)=>{
        try {
            // console.log('row 184 >>', row)
            const payload = {
                customer_id: row.customer_id,
                invoice_id: row.invoice_id,
                invoice_number: row.invoice_number,
                total_formatted: row.total,
                due_date_formatted: row.due_date,
            };
            const invoice = await axios.post(
                `https://webhooks.com.bot/webhook/659e2f526878a30dbd50c72e`,
                payload
            )
            console.log('invoice', invoice)
            if(invoice?.data?.accepted){
                toast.success('Invoice send successfully')
            }
            
        } catch (error) {
            console.log('Error',error)
        }
    }

    const cols = [
        {
            Header: 'Select',
            Cell: ({ row, data }) => (
                <input
                    type="checkbox"
                    checked={selectedRows
                        .map((ele) => ele.invoice_id)
                        .includes(row.original.invoice_id)}
                    onChange={(e) => {
                        e.preventDefault();
                        if (e.target.checked) {
                            setSelectedRows([...selectedRows, row.original]);
                        } else {
                            const data = selectedRows.filter(
                                (item) =>
                                    item.invoice_id !== row.original.invoice_id
                            );
                            setSelectedRows(data);
                        }
                    }}
                />
            ),
        },
        {
            Header: 'SRNO',
            Cell: ({ row, data }) => {
                return 200 * (page - 1) + row.index + 1;
            },
        },
        {
            Header: 'DATE',
            Cell: ({ row }) => {
                // console.log("row",row?.original);
                return moment(row.original.date).format('DD/MM/YYYY');
            },
        },
        {
            Header: 'Invoice No.',
            Cell: ({ row }) => {
                return (
                    <span
                        className="underline text-indigo-500 cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            setInvoicePopupOpen(true);
                            setClickedInvoiceId(row?.original?.invoice_id);
                        }}
                    >
                        {row.original.invoice_number}
                    </span>
                );
            },
        },
        {
            Header: 'Customer Name',
            accessor: 'company_name',
            Cell:({row})=>{
                return(
                    <PhoneIconBox
                        child={<span>{row?.original?.company_name}</span>}
                        blue
                        dot
                        green
                        obj={{contact_id: row?.original?.customer_id}}
                    />
                )
            },
        },
        {
            Header: 'Mobile No',
            accessor: 'cf_mobile_no',
        },

        {
            Header: 'Tracking ID',
            Cell: ({ row }) => {
                return <Tracking trackingData={row?.original} />;
            },
        },
        {
            Header : ' ',
            Cell : ({row})=>{
                return(
                    <div>
                        <SecondaryButton
                            className={'py-1'}
                            onClick={()=> handleSendInvoice(row.original)}
                        >Send Invoice</SecondaryButton>
                    </div>
                )
            }
        },
        {
            Header: 'AMOUNT',
            accessor: 'total',
        },
        {
            Header: 'BALANCE',
            accessor: 'balance',
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <div
                        className="flex gap-2 "
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        {loadingReminder == row.original.invoice_id ? (
                            <ClockLoader size={25} speedMultiplier={2} />
                        ) : (
                            <button
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    setLoadingReminder(
                                        row.original?.invoice_id
                                    );
                                    let popUpData = {
                                        cf_buyer_name:
                                            row.original?.customer_name,
                                    };
                                    //Customer Mobile No.
                                    const customerData = {
                                        search: row.original?.cf_buyer_name,
                                    };
                                    const customerString =
                                        QueryString.stringify(customerData);
                                    const customerContacts =
                                        await authAxiosInstance.get(
                                            `purchase-orders/contacts?${customerString}`
                                        );
                                    console.log(customerContacts, 'new');
                                    if (customerContacts?.data?.data) {
                                        popUpData['customerMobileNo'] =
                                            customerContacts?.data?.data?.contacts?.[0]?.mobile;
                                    }
                                    dispatch(
                                        openReminderPopUp({
                                            isOpen: true,
                                            data: {
                                                ...popUpData,
                                                type: 'customer',
                                                reminderType:
                                                    'invoice_reminder',
                                                path: 'invoices',
                                                path_id:
                                                    row.original?.invoice_id,
                                            },
                                        })
                                    );
                                    setLoadingReminder('');
                                }}
                                className="ml-2"
                            >
                                <Clock
                                    size={25}
                                    color={
                                        row.original[
                                            'cf_customer_inv_reminder'
                                        ] == 'YES'
                                            ? '#ffff1a'
                                            : 'black'
                                    }
                                />
                            </button>
                        )}

                        <Send
                            color={computeColor(
                                row.original.current_sub_status
                            )}
                            className="cursor-pointer "
                            onClick={() =>
                                handleStatusChangeOnSend(row?.original)
                            }
                        />

                        <EditMenu
                            align="right"
                            className="relative inline-flex"
                        >
                            <li>
                                <span
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleInvoiceTrackingId(row?.original);
                                    }}
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Add Tracking Id
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <a
                                    target="_blank"
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                    href={`${row?.original?.cf_po_report_url}`}
                                >
                                    PO Report
                                </a>
                            </li>
                            <hr></hr>
                            <li>
                                <a
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        await authAxiosInstance.post(
                                            'https://app2.com.bot/webhook/65890f53b1f3fea0bf4d2ab0',
                                            {
                                                invoice: {
                                                    customer_id:
                                                        row?.original
                                                            .customer_id,
                                                    custom_field_hash: {
                                                        cf_statement_period:
                                                            row?.original
                                                                .cf_statement_period,
                                                        cf_statement_period_unformatted:
                                                            row?.original
                                                                .cf_statement_period_unformatted,
                                                    },
                                                },
                                            }
                                        );
                                        toast.success('data sent');
                                    }}
                                >
                                    Send Statement PDF
                                </a>
                            </li>
                            <hr></hr>
                            <li>
                                <a
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        await authAxiosInstance.post(
                                            'https://app2.com.bot/webhook/6588eecce0b4c5300af08d0e',
                                            {
                                                receiver: '919913872218',
                                                action: 'pickup',
                                                customer_address:
                                                    row.original.billing_address
                                                        .address,
                                                customer_id:
                                                    row.original.customer_id,
                                            }
                                        );
                                        toast.success('data executed');
                                    }}
                                >
                                    Pick_C/Drop_K(M)
                                </a>
                            </li>
                            <hr></hr>
                            <li>
                                <a
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        await authAxiosInstance.post(
                                            'https://app2.com.bot/webhook/6588eecce0b4c5300af08d0e',
                                            {
                                                receiver: '918758261222',
                                                action: 'pickup',
                                                customer_address:
                                                    row.original.billing_address
                                                        .address,
                                                customer_id:
                                                    row.original.customer_id,
                                            }
                                        );
                                        toast.success('data executed');
                                    }}
                                >
                                    Pick_C/Drop_K(N)
                                </a>
                            </li>
                            <hr></hr>
                            <li>
                                <a
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        await authAxiosInstance.post(
                                            'https://app2.com.bot/webhook/6588eecce0b4c5300af08d0e',
                                            {
                                                receiver: '919913872218',
                                                action: 'drop',
                                                customer_address:
                                                    row.original.billing_address
                                                        .address,
                                                customer_id:
                                                    row.original.customer_id,
                                            }
                                        );
                                        toast.success('data sent');
                                    }}
                                >
                                    Pick_K/Drop_C(M)
                                </a>
                            </li>
                            <hr></hr>
                            <li>
                                <a
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        await authAxiosInstance.post(
                                            'https://app2.com.bot/webhook/6588eecce0b4c5300af08d0e',
                                            {
                                                receiver: '918758261222',
                                                action: 'drop',
                                                customer_address:
                                                    row.original.billing_address
                                                        .address,
                                                customer_id:
                                                    row.original.customer_id,
                                            }
                                        );
                                        toast.success('function executed');
                                    }}
                                >
                                    Pick_K/Drop_C(N)
                                </a>
                            </li>
                        </EditMenu>
                    </div>
                );
            },
        },
    ];

    const handleNext = (e) => {
        e.preventDefault();
        setPage(page + 1);
    };

    const debouncedSearch = useCallback(
        _.debounce((search) => {
            let data = {};
            // if (formik.values.customer) {
            //   data["customer_id"] = formik.values.customer;
            //   (data["date_start"] = moment(formik.values.from).format("YYYY-MM-DD")),
            //     (data["date_end"] = moment(formik.values.to).format("YYYY-MM-DD"));
            // }
            // data["invoice_number_contains"] = search;
            // data[`custom_field_${customIDs.invoice_mobile_no}_contains`] =
            //     search;
            data[`search_text`] =
                search;
            dispatch(
                fetchInvoices({
                    ...data,
                    // search :search,
                    page: 1,
                })
            );
        }, 500),
        [invoices]
    );

    const inVoiceData = useMemo(
        () =>
            invoices.invoices
                ? invoices?.invoices?.filter((el) =>
                      filterStatus.includes(el.current_sub_status)
                  )
                : [],
        [invoices]
    );

    const invoicePageContext = useMemo(
        () => (invoices?.page_context ? invoices.page_context : []),
        [invoices]
    );

    return (
        <>
            {progressLoading ? (
                <ProgressBar totalItem={totalItem} currentItem={currentItem} />
            ) : (
                <div className="p-4">
                    <AddTrackingIdModal
                        updateInvoiceTrackingIdModalOpen={modalIsOpen}
                        setUpdateInvoiceTrackingIdModalOpen={setModalIsOpen}
                        trackingData={invoiceTrackingData}
                    />
                    <PrinterSelect
                        printerSelectModalOpen={printerSelectModalOpen}
                        setPrinterSelectModalOpen={setPrinterSelectModalOpen}
                        selectedPrinter={selectedPrinter}
                        setSelectedPrinter={setSelectedPrinter}
                        selectedRows={selectedRows}
                        printInvoices={printInvoices}
                        printOption={printOption}
                        setPrintOption={setPrintOption}
                    />
                    <InvoiceDataPopup
                        invoicePopupOpen={invoicePopupOpen}
                        setInvoicePopupOpen={setInvoicePopupOpen}
                        clickedInvoiceId={clickedInvoiceId}
                        setClickedInvoiceId={setClickedInvoiceId}
                    />
                    <h1 className="text-lg font-bold col-span-2 mb-3">
                        View Invoice
                    </h1>
                    <TableWithHeadingAndGlobalSearch
                        heading={
                            <div className="flex gap-4">
                                <span className="text-xl">View Invoices</span>
                                {selectedRows?.length > 0 && (
                                    <PrimaryButton onClick={openPrintModal}>
                                        Print
                                    </PrimaryButton>
                                )}
                            </div>
                        }
                        placeholder={`Search for invoice`}
                        data={inVoiceData}
                        loading={loading || isLoading}
                        columns={cols}
                        searchFunction={(search) => {
                            debouncedSearch(search);
                        }}
                    />
                    {!loading && (
                        <div className="mt-4 flex gap-3 justify-end">
                            {page > 1 && (
                                <PrimaryButton
                                    onClick={(e) => setPage(page - 1)}
                                >
                                    Previous
                                </PrimaryButton>
                            )}
                            {invoicePageContext.has_more_page && (
                                <PrimaryButton onClick={(e) => handleNext(e)}>
                                    Next
                                </PrimaryButton>
                            )}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default ViewInvoice;
